import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLStatusKeys } from "Api/Queries/Merchants/useGetOrbitLStatusQuery";
import {
  type SubmitOrbitLOrderResult,
  postMerchantsPublicIDOrbitLSubmit,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
};

type Props = {
  onSuccess?: (data: SubmitOrbitLOrderResult) => void;
  onError?: () => void;
};

export const useSubmitOrbitLOrderMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID }: Parameters) =>
        postMerchantsPublicIDOrbitLSubmit(merchantPublicID),
    ),
    onSuccess: (
      data: SubmitOrbitLOrderResult,
      { merchantPublicID }: Parameters,
    ) => {
      queryClient.invalidateQueries({
        queryKey: orbitLStatusKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
